import { render } from "./ChatItem.vue?vue&type=template&id=40e77d10&scoped=true"
import script from "./ChatItem.vue?vue&type=script&lang=js"
export * from "./ChatItem.vue?vue&type=script&lang=js"

import "./ChatItem.vue?vue&type=style&index=0&id=40e77d10&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e77d10"]])

export default __exports__